import { useEffect } from "react";
import Spinner from "@core/components/loading/Spinner";
import { RemoveScroll } from "react-remove-scroll";

export default function Loading() {
  return (
    <RemoveScroll>
      <div className="fixed top-0 left-0 z-100 flex h-full w-full items-center justify-center overflow-hidden bg-black/20">
        <Spinner />
      </div>
    </RemoveScroll>
  );
}
